<template>
  <div class="wizard">
    <form>
      <form-wizard
        title=""
        subtitle=""
        color="#007bff"
        @on-validate="handleValidation"
        @on-error="handleErrorMessage"
        @on-complete="submitQuote"
        error-color="#e74c3c">
        <tab-content title="Report Type" icon="fa fa-file" :before-change="validateFirstStep">
          <ul class="list-group">
            <li
              class="list-group-item d-flex justify-content-between align-items-center"
              v-for="reportType in reportInfo"
              :key="reportType.uuid"
              :class="{'selected': reportSelected.uuid === reportType.uuid }">
              <a class="interactive-cursor" @click="reportSelected = reportType">
                <img
                  :src="reportType.AppIcon ? 'https://s3-ap-southeast-2.amazonaws.com/roscon/' + reportType.AppIcon.objectKey : require('../../assets/appicons/placeholder.jpg')"
                  class="nav-item-img">{{ reportType.name }}
              </a>
              <i v-if="reportType.details" class="fa fa-info-circle fa-2x text-primary interactive-cursor" @click="showInfo(reportType)"></i>
            </li>
          </ul>
        </tab-content>
        <tab-content title="Property Info" icon="fa fa-building">
          <div class="card">
            <div class="card-body">
              <template v-for="(section, index) in propertyInfoSections">
                <component :key="index" :is="section.type + '-input'" :options="section" v-model="section.value" ref="fields">
                </component>
              </template>
              <template v-for="(section, index) in extraFormSections">
                <component :key="'customField' + index" :is="section.type + '-input'" :options="section" v-model="section.value" ref="fields2">
                </component>
              </template>
            </div>
          </div>
        </tab-content>
        <tab-content title="Request Quote" icon="fa fa-check">
          <div class="card">
            <div class="card-body">
              <template v-for="(section, index) in requestQuoteSections">
                <component :key="index" :is="section.type + '-input'" :options="section" v-model="section.value" ref="fields3">
                </component>
              </template>
            </div>
          </div>
        </tab-content>
        <div class="alert alert-danger mt-2" v-if="errorMsg">
          <i class="fa fa-exclamation-triangle"></i> {{ errorMsg }}
        </div>
      </form-wizard>
    </form>
  </div>
</template>

<style lang="scss">
  .fa.interactive-cursor:hover {
    opacity: 0.6;
  }
  .fa.interactive-cursor {
    transition: all 0.3s ease 0s;
  }
  .list-group-item a.interactive-cursor {
    text-decoration: underline;
    &:hover {
      text-decoration: underline;
      color: #aaa;
    }
  }
  .selected a.interactive-cursor {
    text-decoration: none;
    &:hover {
      text-decoration: none;
      color: #000;
    }
  }
  .stepTitle {
    line-height: 30px;
    font-size: 11px;
    font-weight: 600;
    text-transform: uppercase;
  }
  .selected {
    font-weight: bold;
    background: rgba(186, 219, 255, 0.5);
    z-index: 2;
  }
  .container.report-info img {
    max-width: 100%;
  }
</style>

<script>
  import { FormWizard, TabContent } from 'vue-form-wizard'
  import { mapGetters } from 'vuex'
  import { LOAD_REPORT_INFO, LOAD_FORM, OPEN_MODAL, CLOSE_FORM, SUBMIT_FORM, OPEN_CONFIRMATION_MODAL } from '@/vuex/types'
  import AddressInput from '@/components/inputs/AddressInput'
  import AmazonMediaMultipleInput from '@/components/inputs/AmazonMediaMultipleInput'
  import CalendarInput from '@/components/inputs/CalendarInput'
  import HiddenInput from '@/components/inputs/HiddenInput'
  import NumberInput from '@/components/inputs/NumberInput'
  import ObjectSelectInput from '@/components/inputs/ObjectSelectInput'
  import TextInput from '@/components/inputs/TextInput'
  import RadioInput from '@/components/inputs/RadioInput'
  import dom from '@/util/dom'
  export default {
    name: 'PropertyReportQuoteWizard',
    components: {
      FormWizard,
      TabContent,
      AddressInput,
      CalendarInput,
      AmazonMediaMultipleInput,
      HiddenInput,
      NumberInput,
      ObjectSelectInput,
      RadioInput,
      TextInput
    },
    data () {
      return {
        loadingWizard: false,
        errorMsg: null,
        count: 0,
        reportSelected: false,
        propertyInfoSections: [
          {
            type: 'address',
            label: 'Property Address',
            value: '',
            name: 'propertyAddress'
          },
          {
            type: 'text',
            label: 'Plan of Subdivision Number',
            value: '',
            name: 'planOfSubdivisionNumber'
          },
          {
            type: 'amazon-media-multiple',
            label: 'Attach Strata Plan',
            value: [],
            name: 'attachments'
          },
          {
            type: 'number',
            label: 'Lots',
            value: '2',
            name: 'lots'
          },
          {
            type: 'number',
            label: 'No. of Owners Corporations',
            value: '1',
            name: 'ocNum'
          }
        ],
        requestQuoteSections: [
          {
            name: 'sendEmail',
            type: 'radio',
            label: 'Email Quote',
            radios: [
              { name: 'yes', value: 'yes', label: 'Yes, email the quote to me' },
              { name: 'no', value: 'no', label: 'No, I\'ll download it later' }
            ],
            value: 'no'
          },
          {
            type: 'text',
            label: 'Email',
            value: '',
            name: 'email'
          }
        ],
        extraFormSections: []
      }
    },
    async mounted () {
      await this.$store.dispatch(LOAD_REPORT_INFO)
      this.requestQuoteSections[1].value = this.$user.userData.email
    },
    computed: {
      ...mapGetters([
        'reportInfo'
      ])
    },
    methods: {
      async submitQuote () {
        let elements = this.$refs.fields.concat(this.$refs.fields3)
        if (this.$refs.fields2) {
          elements = elements.concat(this.$refs.fields2)
        }
        let form = { elements }
        let formData = dom(form).serializeForm()
        console.log(formData)
        try {
          await this.$store.dispatch(SUBMIT_FORM, {
            data: { ...formData, permalink: 'propertyReportQuote' }
          })
          this.$store.dispatch(OPEN_CONFIRMATION_MODAL, {
            permalink: 'propertyReportQuote',
            confirmation: 'Your request for quote has been sent',
            redirect: '/client/property-reporting'
          })
        } catch (err) {
          console.log('error submitting form')
        }
      },
      handleValidation (isValid, tabIndex) {
        this.loadWizardForm()
      },
      handleErrorMessage (errorMsg) {
        this.errorMsg = errorMsg
      },
      validateFirstStep () {
        return new Promise((resolve, reject) => {
          if (!this.reportSelected) {
            reject('Please select a report type')
          } else {
            resolve(true)
          }
        })
      },
      async loadWizardForm () {
        let options = {
          permalink: 'propertyReportQuote',
          params: {
            reportUuid: this.reportSelected.uuid
          }
        }
        await this.$store.commit(CLOSE_FORM, options.permalink)
        await this.$store.dispatch(LOAD_FORM, options)
        let sections = this.$store.getters.getForm('propertyReportQuote').sections
        if (sections && sections.length) {
          this.extraFormSections = sections
        } else {
          this.extraFormSections = []
        }
        return true
      },
      async showInfo (reportType) {
        let modal = {
          title: reportType.name,
          html: '<div class="container report-info" id="reportInfo">' + reportType.details + '</div>'
        }
        await this.$store.dispatch(OPEN_MODAL, modal)
        await this.$nextTick()
        let elem = document.getElementById('reportInfo')
        let imgs = elem.getElementsByTagName('img')
        for (let img of imgs) {
          img.style.removeProperty('height')
          img.removeAttribute('height')
        }
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/client/PropertyReportQuoteWizard.vue